import React, { useEffect } from 'react';
import Header from '../components/Header/Header';
import Hero from '../components/Hero/Hero';
import Services from '../components/Services/Services';
import ContactForm from '../components/ContactForm/ContactForm';
import Reviews from '../components/Reviews/Reviews';
import Footer from '../components/Footer/Footer';
import AnnouncementBanner from '../components/AnnouncementBanner/AnnouncementBanner';
import { setPageMetadata } from '../utils/seo';

const Home = () => {
  useEffect(() => {
    setPageMetadata({
      title: 'Мигрант PRO — РВП, ВНЖ, гражданство РФ и переводы в Подольске',
      description: 'Помощь с оформлением РВП, ВНЖ и гражданства РФ, а также переводом документов в Подольске. Бесплатная консультация Мигрант PRO.',
    });
  }, []);

  return (
    <>
      <Header />
      <Hero />
      <Services />
      <ContactForm />
      <Reviews />
      <Footer />
      <AnnouncementBanner />
    </>
  );
};

export default Home;
